require('./dropdownPlans.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ components
const PlanItem = require('./planItem');

class PlanItemOptions extends React.Component {

    constructor() {
        super();
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
    }

    handleMouseDown (event) {
        const { option } = this.props;
        event.preventDefault();
        event.stopPropagation();
        if(option.totalValue || !option.isOrigin) {
            this.props.onSelect(this.props.option, event);
        }
    }

    handleMouseMove (event) {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
    }

    render () {
        const {option, className } = this.props;
        const plan = option;
        const id = `${plan.id}_Options_${plan.value}`;
        const planClass = `${className} dropdown-plans__account`;
        const innerClass = !plan.totalValue && plan.isOrigin ? 
            `${planClass}--disabled` : `${planClass}--enabled`;

        return (
            <div
                id={id}
                className={innerClass}
                onMouseDown={this.handleMouseDown}
                onMouseMove={this.handleMouseMove}
                >
                <div className="dropdown-plans__account-description dropdown-plans__account-description--height">
                    <PlanItem plan={plan}/>
                </div>
            </div>
        );
    }
}

PlanItemOptions.propTypes = {
    className: PropTypes.string,
    onSelect: PropTypes.func,
    option: PropTypes.object,
    onFocus: PropTypes.func,
    isFocused: PropTypes.bool
};

module.exports = PlanItemOptions;